import React, { useContext, useEffect, useState } from "react";
import "../../../css/campaign.css";
import { Badge, Box, CircularProgress } from "@mui/material";
import InstagramIcon from '@mui/icons-material/Instagram';
import moment from "moment/moment";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getCampaign } from "../live-campaign-repository";
import { UserDetailsContext } from "../../context/user-details-context";
import MailIcon from '@mui/icons-material/Mail';

function LiveCampaignDetails() {
    const location = useLocation();
    const navigate = useNavigate();
    const pathname = window.location.pathname;
    const pathSegments = pathname.split('/');
    const startPath = '/' + pathSegments[1];
    const { loggedUser } = useContext(UserDetailsContext);
    const [campaign, setCampaign] = useState();
    const [campaignid] = useState(location.state.campaignid);

    useEffect(() => {
        getCampaign(campaignid, setCampaign);
    }, [campaignid, loggedUser]);

    const handleCampaignApplication = () => {
        const pathSegments = pathname.split('/');
        const startPath = '/' + pathSegments[1];
        navigate(`${startPath}/applications`, { state: { campaignId: campaign.campaignId, campaignName: campaign.campaignName, noOfCreators: campaign.creators, campaignClosed: campaign.campaignClosed, page: 'details' } });
    }

    return (
        <>
            {!campaign ? (
                <div className="data-loading">
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <CircularProgress />
                    </Box>
                </div>
            ) : (
                <Box component="main" sx={{ width: "100%" }}>
                    <div className="main-content">
                        <div className="campaign-details">
                            <div className="campaign-details-head">
                                <ArrowBackIcon className="arrow-back" onClick={() => navigate(`${startPath}/${campaign.status.toLowerCase()}`)}></ArrowBackIcon>
                                <h1 className="campaign-header-name">{campaign.campaignName}</h1>
                                <div className="socialmedia-btn lite">
                                    <InstagramIcon sx={{ fontSize: 20 }} />
                                    <label>Instagram</label>
                                </div>
                            </div>
                            <div className="campaign-details-options">
                                <Badge onClick={() => { handleCampaignApplication(); }}
                                    sx={{ cursor: 'pointer' }}
                                    color="secondary" badgeContent={campaign.campaignApplicants != null && campaign.campaignApplicants.length > 0 && campaign.campaignApplicants.filter(applicant => applicant.appliedStatus === 'Apply').length > 0 ? campaign.campaignApplicants.filter(applicant => applicant.appliedStatus === 'Apply').length : 0} showZero>
                                    <MailIcon />
                                </Badge>
                            </div>
                            <div className="campaign-list-hr"></div>
                            <div className="campaign-overview">
                                <div className="campaign-overview-header">
                                    <h1>Campaign Overview</h1>
                                </div>
                                <div className="campaign-data">
                                    <div>Channel: <span>Instagram</span></div>
                                    <div className="option-row">
                                        <div>Campaign approved: <span>{moment(campaign.approvedDate).format("ll")}</span></div>
                                        <div>Last date of application: <span>{moment(campaign.lastDateOfApplication).format("ll")}</span></div>
                                    </div>
                                    <div>Created By: <span>{campaign.createdBy === null ? "Unknown" : campaign.createdBy.fullName}</span></div>
                                    <div>Campaign Owner: <span>{campaign.campaignOwner.companyName}</span></div>
                                    <div>Brand: <span>{campaign.brand != null ? campaign.brand.name : null}</span></div>
                                    <div className="description-outer-container">
                                        <div className="adjust-alignment campaign-brief">Brief:</div>
                                        <div>
                                            <div className="description-content" dangerouslySetInnerHTML={{ __html: campaign.description }} />
                                        </div>
                                    </div>
                                    <div>Project Type: <span>{campaign.projectType?.projectType}</span></div>
                                    <div>Shoot Location Type: <span>{campaign.shootLocationType?.shootLocationType}</span></div>
                                    <div>Languages: <span>{campaign.languages?.map(lang => lang.language).join(", ")}</span></div>
                                    <div>Gender: <span>{campaign.gender?.join(", ")}</span></div>
                                    <div>Age Range: <span>{campaign.ageRange?.map(ar => ar.ageRange).join(", ")}</span></div>
                                    <div>Target Types: <span>
                                        {campaign.categoryTypes && campaign.categoryTypes.some(item => item !== '') ? campaign.categoryTypes.join(', ') : ''}
                                        {campaign.categoryTypes && campaign.categoryTypes.some(item => item !== '') && campaign.customCategory && campaign.customCategory.some(item => item !== '') ? ', ' : ''}
                                        {campaign.customCategory && campaign.customCategory.some(item => item !== '') ? campaign.customCategory.filter(item => item !== '').map(item => item.replace(/"/g, '')).join(', ') : ''}
                                    </span></div>
                                    <div>Campaign Category Type: <span>{campaign.campaignCategoryType?.campaignCategoryType}</span></div>
                                    <div>Location: <span>{campaign.campaignLocations ? campaign.campaignLocations.map(cityState => `${cityState}`).join(', ') : ''}</span></div>
                                    <div>Number of creators: <span>{campaign.creators}</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Box>
            )
            }
        </>
    )
}

export default LiveCampaignDetails;
